import { useCallback, useEffect, useState } from "react";

// Screen size breakpoints from ARC-3
const MEDIUM_BREAKPOINT = 575;
const LARGE_BREAKPOINT = 1024;
const EXTRA_LARGE_BREAKPOINT = 1280;

export const ScreenSizes = {
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE",
  EXTRA_LARGE: "EXTRA_LARGE"
};

/** Returns the current screen size (SMALL/MEDIUM/LARGE/EXTRA_LARGE) */
export const useScreenSize = () => {
  const determineScreenSize = windowWidth => {
    if (windowWidth < MEDIUM_BREAKPOINT) return ScreenSizes.SMALL;
    if (windowWidth < LARGE_BREAKPOINT) return ScreenSizes.MEDIUM;
    if (windowWidth < EXTRA_LARGE_BREAKPOINT) return ScreenSizes.LARGE;
    return ScreenSizes.EXTRA_LARGE;
  };

  const [screenSize, setScreenSize] = useState(determineScreenSize(window.innerWidth));

  const updateMinWidth = useCallback(() => {
    return setScreenSize(determineScreenSize(window.innerWidth));
  });

  useEffect(() => {
    window.addEventListener("resize", updateMinWidth);
    return () => {
      window.removeEventListener("resize", updateMinWidth);
    };
  }, []);

  return screenSize;
};
